<template>
    <!-- BEGIN login -->
    <div class="login login-with-news-feed">
        <!-- BEGIN news-feed -->
        <div class="news-feed">
            <div class="news-image" style="background-image: url(/assets/img/login-bg/login-bg-11.jpg)"></div>
            <div class="news-caption">
                <h4 class="caption-title"><b>{{ $appSettings.appName }}</b> Admin</h4>
                <p>
                    {{ $appSettings.appWelcomeMessage }}
                </p>
            </div>
        </div>
        <!-- END news-feed -->

        <!-- BEGIN login-container -->
        <div class="login-container">
            <!-- BEGIN login-header -->
            <div class="login-header mb-30px">
                <div class="brand">
                    <div class="d-flex align-items-center">
                        <span class="logo"></span>
                        <b>Zmień hasło</b>
                    </div>
                </div>
                <div class="icon">
                    <i class="fa fa-key"></i>
                </div>
            </div>
            <!-- END login-header -->

            <!-- BEGIN login-content -->
            <div class="login-content">
                <p class="text-center pv" v-if="!expired">Hasło którym się zalogowałeś jest tymczasowe.<br />Musisz je zmienić.</p>
                <p class="text-center pv" v-if="expired">Twoje hasło straciło ważność.<br />Musisz je zmienić.</p>
                <ValidationObserver v-slot="{ handleSubmit }">
                    <input-field type="password_create" label="Nowe hasło" name="password" v-model="login.password" rules="required" ></input-field>
                    <div class="mb-15px">
                        <button type="button" class="btn btn-success d-block h-45px w-100 btn-lg fs-14px" @click="handleSubmit(onSubmit)" :disabled="isBusy">Zapisz</button>
                    </div>
                </ValidationObserver>
                <!--					<div class="mb-40px pb-40px text-dark">-->
                <!--						Not a member yet? Click <router-link to="/user/register-v3" class="text-success">here</router-link> to register.-->
                <!--					</div>-->
                <hr class="bg-gray-600 opacity-2" />
                <div class="text-gray-600 text-center text-gray-500-darker mb-0">
                    &copy; {{ $appSettings.appProducer }} All Right Reserved {{ moment().format('YYYY') }}
                </div>

            </div>
            <!-- END login-content -->
        </div>
        <!-- END login-container -->
    </div>
    <!-- END login -->
</template>

<script>
import AppOptions from '@/config/AppOptions.vue'
import InputField from "@/components/Forms/InputField";
import * as TYPES from '@/store/types';
export default {
    components: {
        InputField
    },
    computed: {
        expired() {
            return this.$route.meta.expired;
        },
    },
    data() {
        return {
            moment,
            login: {
                email: '',
                password: '',
            },
            isBusy: false,
        }
    },
    created() {
        AppOptions.appEmpty = true;
    },
    beforeRouteLeave (to, from, next) {
        AppOptions.appEmpty = false;
        next();
    },
    methods: {
        onSubmit() {
            this.isBusy = true;
            this.$store.dispatch(TYPES.AUTH_USER_SET_NEW_PASSWORD, {
                password: this.login.password,
                redirect: this.$route.query.redirect
            }).finally(() => {
                this.isBusy = false;
            })
        },
    },
}
</script>